import type { ReactNode } from 'react'

/** Flat surface container — hairline border on the surface token, minimal
 *  shadow. The ops-console replacement for the old marketing `.card`
 *  (heavy shadow + black/10 border). */
export function Panel({
  className = '',
  children,
}: {
  className?: string
  children: ReactNode
}) {
  return (
    <div className={`rounded-lg border border-line bg-surface ${className}`}>{children}</div>
  )
}

/** Optional titled header row inside a Panel. Title + optional right-side
 *  meta/actions, separated from the body by a hairline. */
export function PanelHeader({
  title,
  meta,
  className = '',
}: {
  title: ReactNode
  meta?: ReactNode
  className?: string
}) {
  return (
    <div
      className={`flex items-center justify-between gap-3 border-b border-line px-4 py-3 ${className}`}
    >
      <h2 className="text-sm font-semibold text-ink">{title}</h2>
      {meta ? <div className="flex items-center gap-2 text-sm text-ink-soft">{meta}</div> : null}
    </div>
  )
}
